export default __webpack_public_path__ + "static/media/six-dots.d26ff67d.svg";